/**
 * Replaces whitespaces and special characters with dashes for generating ids. Transforms uppercase letters to lowercase
 */
export function formatId(content: string, replacingChar = '-') {
  return content.replace(/\s+/g, replacingChar).replace(/[!@#$%^&*()';,./?><+]/g, '').toLowerCase();
}

